export default "__VITE_ASSET__xpj5n0DM__"